import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/index';

export const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
@Injectable({
  providedIn: 'root'
})
export class SupplierBaseService extends BaseService {
  constructor(http:HttpClient) {
    super(http);
  }

  private url = 'api/supplier';
  private businessListUrl = 'api/dict-tables/search-with-list?dictCode=businessModel';

  getUrl():string {
    return this.url;
  }

  getBuiness():Observable<any> {
    return this.http.get(this.businessListUrl,
      {
        headers: httpOptions.headers,
      }
    ).pipe(
      tap(() => this.log('getBuiness')),
      catchError(this.handleError('getBuiness'))
    );
  }

  refuseReg(ids):Observable<any> {
    const url = `${this.getUrl()}/refuse-reg`;
    return this.http.get<any>(url, {params: {id: ids}}).pipe(
      tap(_ => this.log(`refuse-reg`)),
      catchError(this.handleError<any>(`refuse-reg`))
    );
  }

  cancelRefuse(ids):Observable<any> {
    const url = `${this.getUrl()}/cancel-refuse`;
    return this.http.get<any>(url, {params: {id: ids}}).pipe(
      tap(_ => this.log(`cancel-refuse`)),
      catchError(this.handleError<any>(`cancel-refuse`))
    );
  }

  redendRegEmail(ids):Observable<any> {
    const url = `${this.getUrl()}/resend-reg-email`;
    return this.http.get<any>(url, {params: {id: ids}}).pipe(
      tap(_ => this.log(`resend-reg-email`)),
      catchError(this.handleError<any>(`resend-reg-email`))
    );
  }

  fieldGroupAll():Observable<any> {
    const url = `${this.getUrl()}/field-group-all`;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`resend-reg-email`)),
      catchError(this.handleError<any>(`resend-reg-email`))
    );
  }

  syncAllSupplier():Observable<any> {
    return this.http.get('api/supplier/sync-all',
      {
        headers: httpOptions.headers,
      }
    ).pipe(
      tap(() => this.log('getBuiness')),
      catchError(this.handleError('getBuiness'))
    );
  }

  customSync(params):Observable<any> {
    return this.http.get('api/supplier/sync',
      {
        headers: httpOptions.headers,
        params: params
      }
    ).pipe(
      tap(() => this.log('getBuiness')),
      catchError(this.handleError('getBuiness'))
    );
  }

  //同步至erp
  toErp(id:any):Observable<any> {
    const url = `api/supplier/to-erp`;
    return this.http.get<any>(url, {headers: httpOptions.headers, params: {supplierId: id}}).pipe(
      tap(_ => this.log(`toErp`)),
      catchError(this.handleError<any>(`toErp`))
    );
  }

  syncOne(id:any):Observable<any> {
    const url = `api/supplier/sync-one`;
    return this.http.get<any>(url, {headers: httpOptions.headers, params: {supplierId: id}}).pipe(
      tap(_ => this.log(`syncOne`)),
      catchError(this.handleError<any>(`syncOne`))
    );
  }

  /**
   * 根据模块获取供应商信息
   * @param id 供应商id
   * @param module 要获取的模块
   */
  getSupInfoByModule(id,module):Observable<any> {
    let params = {
      supplierId:id,
      supModule:module
    };
    return this.http.get(this.url+"/get-dto",
      {
        headers: httpOptions.headers,
        params:params
      }
    ).pipe(
      tap(() => this.log('getSupInfoByModule')),
      catchError(this.handleError('getSupInfoByModule'))
    );
  }

  getSupplierBySupplierCode(supplierCode):Observable<any> {
    const url = `${this.getUrl()}/find-by-supplier-code/`+supplierCode;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`供应商查询出错`)),
      catchError(this.handleError<any>(`供应商查询出错`))
    );
  }

  getSupplierBySupplierErpCode(supplierCode):Observable<any> {
    const url = `${this.getUrl()}/find-by-supplier-erpcode/`+supplierCode;
    return this.http.get<any>(url).pipe(
      tap(_ => this.log(`供应商查询出错`)),
      catchError(this.handleError<any>(`供应商查询出错`))
    );
  }

}
